import { ThemeProvider } from 'styled-components';
import App from './components/App';
import GlobalStyle from './styles/globalStyle.js';
import Loading from './components/Loading.js';
import Login from './components/Login';
import React from 'react';
import ReactDOM from 'react-dom/client';
import useStore from './utils/useStore.js'

function Index() {
  const store = useStore();
  const theme = {
    darkmode: store.state.darkmode,
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      { store.state.token && <App store={ store } />}
      { !store.state.token && <Login store={ store } />}
      <Loading store={ store } />
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Index />
  </React.StrictMode>
);
